import { useMemo } from 'react';
import cx from 'classnames';

import styles from './IncodeSdkPage.scss';

export const INCODE_CONTAINER_TEST_ID = 'incode-container';

export const IncodeContainer = (
  {
    className,
    noStyling,
    ref,
  }: { className?: string; noStyling?: boolean; ref: React.RefObject<HTMLDivElement | null> },
) => useMemo(() => (
  <div
    ref={ref}
    className={cx({ [styles.incodeContainer]: !noStyling }, className)}
    data-testid={INCODE_CONTAINER_TEST_ID}
  />
), [ref, noStyling, className]);
